import { Banner } from "@shopify/polaris";
import { useState } from "react";
import StoreDetails from "./subcomponents/StoreDetails";
import MSMF from "./subcomponents/MSMF";
import DefaultSettings from "./subcomponents/DefaultSettings";
import SyncSettings from "./subcomponents/SyncSettings";
import FeedRules from "./subcomponents/FeedRules";
import ScheduledSyncSettings from "./subcomponents/ScheduledSyncSettings";
import { usePlan } from "../context/PlanContext";

const ShopifyStoreDetails = () => {
  const [visible, setVisible] = useState(false);
  const { hasFeature } = usePlan();
  const handleBanner = (val) => {
    setVisible(val);
    setTimeout(() => {
      setVisible(false);
    }, 6000);
  };

  return (
    <div>
      {visible ? (
        <div style={{ marginBottom: 12 }}>
          <Banner
            tone="info"
            title="Processing - Sync Metafields for all products has been started"
          />
        </div>
      ) : null}

      <div className="settings-panel">
        <SyncSettings />
        <div className="settings-panel__side">
          <StoreDetails />
          <ScheduledSyncSettings />
          <FeedRules />
          {hasFeature("metafield_sync") ? (
            <MSMF handleBanner={handleBanner} />
          ) : null}
          <DefaultSettings />
        </div>
      </div>
    </div>
  );
};

export default ShopifyStoreDetails;
